import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }
  reset = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-screen grid place-items-center px-6">
          <div className="frumy-card max-w-md w-full p-8 text-center">
            <span className="inline-grid place-items-center h-14 w-14 rounded-full bg-amber-50 text-[var(--frumy-lock)] mb-5 text-2xl font-bold">!</span>
            <h1 className="font-display text-2xl font-extrabold text-[var(--frumy-navy)]">Qualcosa è andato storto</h1>
            <p className="text-sm text-slate-600 mt-3">
              Si è verificato un errore imprevisto. Riprova o torna alla pagina iniziale.
            </p>
            <button data-testid="error-boundary-reset" onClick={this.reset}
              className="pill-btn cta-metal mt-6 inline-flex items-center justify-center text-white font-bold px-6 py-3">
              Torna alla home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
